import { FormattedMessage } from '@umijs/max';
import antdEnUS from 'antd/lib/locale/en_US';
import component from './en-US/component';
import globalHeader from './en-US/globalHeader';
import menu from './en-US/menu';
import pages from './en-US/pages';
import pwa from './en-US/pwa';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';
import register from './en-US/register';
import memberWelcome from './en-US/memberWelcome';
import staff from './en-US/staff';
import memberList from './en-US/memberList';
import dashboard from './en-US/dashboard';

export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.copyright.produced': 'Produced by Blue Ocean Tech Studio',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list': 'Quickly build standard, pages based on `block` development',
  
  // 403 page
  'pages.403.subTitle': 'Sorry, you are not authorized to access this page.',
  'pages.403.back': 'Back to home',
  
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
  ...register,
  ...memberWelcome,
  ...staff,
  ...memberList,
  ...dashboard,
  'menu.account.logout': 'Logout',
  'menu.account.logout.confirm': 'Confirm Logout',
  'menu.account.logout.confirm.content': 'Are you sure you want to log out?',
  'menu.account.logout.success': 'Successfully logged out',
  'menu.account.logout.failed': 'Logout failed',
  
  'menu.account.changePassword': 'Change Password',
  'menu.account.changePassword.currentPassword': 'Current Password',
  'menu.account.changePassword.currentPassword.required': 'Please enter current password',
  'menu.account.changePassword.newPassword': 'New Password',
  'menu.account.changePassword.newPassword.required': 'Please enter new password',
  'menu.account.changePassword.password.tooShort': 'Password must be at least 6 characters',
  'menu.account.changePassword.confirmPassword': 'Confirm Password',
  'menu.account.changePassword.confirmPassword.required': 'Please confirm your new password',
  'menu.account.changePassword.passwordMismatch': 'The two passwords do not match',
  'menu.account.changePassword.success': 'Password changed successfully',
  'menu.account.changePassword.failed': 'Failed to change password',
  'menu.account.changePassword.incorrectPassword': 'Current password is incorrect',
  'pages.memberList.pagination.total': 'Total {total} items',
  'pages.memberList.pagination.pageSize': 'items/page',
  'pages.memberList.pagination.jump': 'Jump to',
  'pages.memberList.pagination.page': 'page',
  
  // Gift Card List
  'pages.giftCardList.title': 'Gift Card List',
  'pages.giftCardList.create': 'Create Gift Card',
  'pages.giftCardList.createVirtual': 'Create Virtual Gift Card',
  'pages.giftCardList.createPhysical': 'Create Physical Gift Card',
  'pages.giftCardList.downloadPhysical': 'Download Physical Card Numbers',
  'pages.giftCardList.code': 'Card Number',
  'pages.giftCardList.physicalCardNumber': 'Physical Card Number',
  'pages.giftCardList.value': 'Value',
  'pages.giftCardList.initialAmount': 'Initial Amount',
  'pages.giftCardList.balance': 'Balance',
  'pages.giftCardList.balanceStatus': 'Balance',
  'pages.giftCardList.balanceStatus.all': 'All gift cards',
  'pages.giftCardList.balanceStatus.withBalance': 'With balance',
  'pages.giftCardList.balanceStatus.withoutBalance': 'Without balance',
  'pages.giftCardList.status': 'Status',
  'pages.giftCardList.createTime': 'Create Time',
  'pages.giftCardList.activeDate': 'Active Date',
  'pages.giftCardList.activeBy': 'Active By',
  'pages.giftCardList.activationStatus': 'Activation Status',
  'pages.giftCardList.activationStatus.all': 'All gift cards',
  'pages.giftCardList.activationStatus.active': 'Activated',
  'pages.giftCardList.activationStatus.inactive': 'Inactive',
  'pages.giftCardList.expiryDate': 'Expiry Date',
  'pages.giftCardList.validDays': 'Validity (Days)',
  'pages.giftCardList.actions': 'Actions',
  'pages.giftCardList.actions.details': 'Details',
  'pages.giftCardList.note': 'Note',
  'pages.giftCardList.date': 'Date Range',
  'pages.giftCardList.refresh': 'Refresh',
  'pages.giftCardList.email': 'Email',
  'pages.giftCardList.phone': 'Phone',
  'pages.giftCardList.tempEmail': 'Temporary Email',
  'pages.giftCardList.tempPhone': 'Temporary Phone',
  'pages.giftCardList.contactInfo': 'Contact Type',
  'pages.giftCardList.search.infoType.placeholder': 'Select contact type',
  'pages.giftCardList.contactValue': 'Contact Value',
  'pages.giftCardList.search.infoValue.placeholder': 'Enter contact information',
  'pages.giftCardList.createDate': 'Create Date',
  
  'pages.giftCardList.search.code.placeholder': 'Enter card number',
  'pages.giftCardList.search.cardNumber': 'Card ID / Physical Card Number',
  'pages.giftCardList.search.status.placeholder': 'Select status',
  'pages.giftCardList.search.date.start': 'Start date',
  'pages.giftCardList.search.date.end': 'End date',
  'pages.giftCardList.search.submit': 'Search',
  'pages.giftCardList.search.reset': 'Reset',
  
  'pages.giftCardList.create.success': 'Gift card created successfully',
  'pages.giftCardList.create.error': 'Gift card creation failed',
  'pages.giftCardList.create.value.required': 'Please enter gift card value',
  'pages.giftCardList.create.value.placeholder': 'Please enter gift card value',
  'pages.giftCardList.create.balance.required': 'Please enter initial balance',
  'pages.giftCardList.create.balance.placeholder': 'Please enter initial balance',
  'pages.giftCardList.create.initialAmount.required': 'Please enter the initial amount',
  'pages.giftCardList.create.initialAmount.placeholder': 'Please enter the initial amount',
  'pages.giftCardList.create.email.placeholder': 'Please enter email',
  'pages.giftCardList.create.phone.placeholder': 'Please enter phone number',
  'pages.giftCardList.create.expiryDate.placeholder': 'Please select expiry date',
  'pages.giftCardList.create.validDays.required': 'Please enter the validity in days',
  'pages.giftCardList.create.validDays.placeholder': 'Please enter the number of valid days',
  'pages.giftCardList.create.note.placeholder': 'Please enter note',
  'pages.giftCardList.physical.issuingStore': 'Issuing Store',
  'pages.giftCardList.physical.storeRequired': 'Please select an Issuing Store',
  'pages.giftCardList.physical.quantity': 'Quantity',
  'pages.giftCardList.physical.batch': 'Creation Batch',
  'pages.giftCardList.physical.allBatches': 'All Physical Gift Cards',
  'pages.giftCardList.physical.loadError': 'Failed to load Physical Gift Card options',
  'pages.giftCardList.physical.createSuccess': 'Created {count} Physical Gift Cards',
  'pages.giftCardList.physical.createError': 'Failed to create Physical Gift Cards',
  'pages.giftCardList.physical.batchLoadError': 'Failed to load Physical Gift Card batches',
  'pages.giftCardList.physical.downloadError': 'Failed to download Physical Card Numbers',
  
  'pages.giftCardList.level': 'Gift Card Type',
  'pages.giftCardList.create.level.required': 'Please select gift card type',
  'pages.giftCardList.create.level.placeholder': 'Please select gift card type',
  'pages.giftCardList.error.headOffice': 'Failed to get head office information',
  'pages.giftCardList.error.fetchLevels': 'Failed to fetch gift card types',
  'pages.giftCardList.error.storeId': 'Store ID not found',
  'pages.giftCardList.error.invalidStoreId': 'Invalid store ID format',
  'pages.giftCardList.error.fetchFailed': 'Failed to fetch gift card list',
  'pages.giftCardList.error.fetchStoreFailed': 'Failed to fetch store information',
  'pages.giftCardList.error.noLevels': 'No gift card types found. Please create gift card types in the admin panel first',
  
  'pages.giftCardList.status.active': 'Active',
  'pages.giftCardList.status.inactive': 'Inactive',
  'pages.giftCardList.status.expired': 'Expired',
  'pages.giftCardList.status.used': 'Used',
  'pages.giftCardList.status.cancelled': 'Cancelled',
  
  'pages.giftCardList.pagination.total': 'Total {total} items',
  'pages.giftCardList.pagination.pageSize': 'items/page',
  'pages.giftCardList.pagination.jump': 'Jump to',
  'pages.giftCardList.pagination.page': 'page',
  
  'app.common.cancel': 'Cancel',
  'app.common.create': 'Create',
  'pages.store.giftCardDetails.send.email': 'Send Email',
  'pages.store.giftCardDetails.send.phone': 'Send SMS',
  'pages.store.giftCardDetails.send.card': 'Send Card',
  'pages.store.giftCardDetails.send.wallet': 'Add to Wallet',
  'pages.store.giftCardDetails.email.placeholder': 'Enter email',
  'pages.store.giftCardDetails.phone.placeholder': 'Enter phone number',

  // Additional translations for messages and missing labels.
  'app.common.request.error': 'Request failed. Please try again.',
  'app.common.request.noResponse': 'No response from the server. Please try again.',
  'pages.store.giftCardDetails.email.invalid': 'Please enter a valid email address',
  'pages.store.giftCardDetails.expiry.placeholder': 'Select expiry time',
  'pages.store.giftCardDetails.send.sms.success': 'Gift card SMS sent successfully',
  'pages.store.giftCardDetails.send.email.success': 'Gift card email sent successfully',
  'pages.store.giftCardDetails.send.error': 'Failed to send gift card. Please try again.',
  'pages.store.giftCardDetails.unavailable': 'Gift card information is unavailable',
  'pages.store.giftCardDetails.phone.missing': 'No phone number is linked to this gift card',
  'pages.store.giftCardDetails.email.missing': 'No email address is linked to this gift card',
  'pages.store.giftCardDetails.fetch.error': 'Failed to load gift card details',
  'pages.store.giftCardDetails.edit.success': 'Gift card information updated successfully',
  'pages.store.giftCardDetails.edit.error': 'Failed to update gift card information',
  'pages.store.memberDetails.send.sms.success': 'Member card SMS sent successfully',
  'pages.store.memberDetails.send.email.success': 'Member card email sent successfully',
  'pages.store.memberDetails.send.error': 'Failed to send member card. Please try again.',
  'pages.store.memberDetails.fetch.error': 'Failed to load member details',
  'pages.store.memberDetails.headOffice.error': 'Unable to load head office information',
  'pages.store.memberDetails.levels.error': 'Failed to load membership levels',
  'pages.store.memberDetails.unavailable': 'Member information is unavailable',
  'pages.store.memberDetails.points.modify.success': 'Points modified successfully',
  'pages.store.memberDetails.points.modify.error': 'Failed to modify points',
  'pages.store.voucherDetails.fetch.error': 'Failed to load voucher details',
  'pages.store.voucherDetails.unavailable': 'Voucher information is unavailable',
  'pages.store.voucherDetails.edit.success': 'Voucher information updated successfully',
  'pages.store.voucherDetails.edit.error': 'Failed to update voucher information',
  'app.common.invalidParams': 'Invalid parameters',
  'app.common.user.fetch.error': 'Failed to load user information',
  'account.center.articles': 'Articles',
  'account.center.applications': 'Applications',
  'account.center.projects': 'Projects',
  'account.center.tags': 'Tags',
  'account.center.team': 'Team',
  'pages.admin.subPage.title': 'Only administrators can view this page',
  'pages.welcome.alertMessage': 'Faster and more powerful components are now available.',
  'dashboard.analysis.introduce': 'Metric description',
  'dashboard.analysis.action1': 'Action 1',
  'dashboard.analysis.action2': 'Action 2',
  'dashboard.analysis.sales': 'Sales',
  'pages.voucherList.modal.fetchMemberLevelsFailed': 'Failed to load membership levels',
  'pages.headOffice.settings.title': 'Head Office Settings',
  'pages.orderDetails.PointsBalanceAfterTransaction': 'Points Balance After Transaction',
  'pages.orderDetails.cardUsedAmount': 'Card Amount Used',
  'pages.orderDetails.BalanceAfterTransaction': 'Balance After Transaction',
  'pages.orderDetails.spentValue': 'Amount Spent',
  'component.message.success': 'Operation successful',
  'component.message.failed': 'Operation failed',
  'component.message.required': 'This field is required',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule Configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Rule Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Target',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Start Time',
  'pages.searchTable.tenThousand': 'Ten Thousand',
  'pages.searchTable.exception': 'Please enter the reason for the exception',
  'pages.searchTable.title': 'Search Table',
  'memberPortal.profile.resetPassword.success': 'Password reset successfully',
  'memberPortal.profile.resetPassword.error': 'Failed to reset password',
  'memberPortal.profile.save.success': 'Profile updated successfully',
  'memberPortal.profile.save.error': 'Failed to update profile',
  'memberPortal.profile.email.invalid': 'Please enter a valid email address',
  'memberPortal.profile.mobile.invalid': 'Mobile number must start with 04 and be 10 digits',
  'memberPortal.profile.verification.sent': 'Verification code sent successfully',
  'memberPortal.profile.verification.sendError': 'Failed to send verification code',
  'memberPortal.profile.phone.updateSuccess': 'Phone number updated successfully',
  'memberPortal.profile.phone.updateError': 'Failed to update phone number',
  'memberPortal.loading.full': 'Loading store resources...',
  'memberPortal.profile': 'Profile',
  'memberPortal.profile.points': 'Current Points',
  'memberPortal.transactions': 'Transactions',
  'memberPortal.profile.memberId': 'Member ID',
  'memberPortal.profile.name': 'Name',
  'memberPortal.profile.firstName': 'First Name',
  'memberPortal.profile.middleName': 'Middle Name',
  'memberPortal.profile.lastName': 'Last Name',
  'memberPortal.profile.mobile': 'Mobile',
  'memberPortal.profile.mobile.required': 'Please enter mobile number',
  'memberPortal.profile.mobilePlaceholder': 'Enter mobile number',
  'memberPortal.profile.email': 'Email',
  'memberPortal.profile.emailPlaceholder': 'Enter email',
  'memberPortal.profile.ageGroup': 'Age Group',
  'memberPortal.profile.ageGroupPlaceholder': 'Select age group',
  'memberPortal.profile.registerTime': 'Registration Time',
  'memberPortal.profile.cancel': 'Cancel',
  'memberPortal.profile.save': 'Save',
  'memberPortal.profile.edit': 'Edit',
  'memberPortal.profile.logout': 'Logout',
  'memberPortal.profile.resetPassword': 'Reset Password',
  'memberPortal.history.filter': 'Filter by Date',
  'memberPortal.history.selectDate': 'Select date',
  'memberPortal.history.clearFilter': 'Clear',
  'memberPortal.history.empty': 'No transaction history',
  'memberPortal.history.store': 'Store',
  'memberPortal.history.invoice': 'Invoice',
  'memberPortal.history.status': 'Status',
  'memberPortal.history.reward': 'Reward',
  'memberPortal.history.redeem': 'Redeem',
  'memberPortal.history.after': 'Balance',
  'memberPortal.history': 'History',
  'memberPortal.profile.logout.confirm': 'Confirm Logout',
  'memberPortal.profile.logout.message': 'You will be redirected to the registration page after logout.',
  'memberPortal.profile.logout.cancel': 'Cancel',
  'memberPortal.profile.resetPassword.title': 'Reset Password',
  'memberPortal.profile.resetPassword.newPassword': 'New Password',
  'memberPortal.profile.resetPassword.newPasswordRequired': 'Please enter new password',
  'memberPortal.profile.resetPassword.passwordMinLength': 'Password must be between 6 and 16 characters',
  'memberPortal.profile.resetPassword.newPasswordPlaceholder': 'Enter new password',
  'memberPortal.profile.resetPassword.confirmPassword': 'Confirm Password',
  'memberPortal.profile.resetPassword.confirmPasswordRequired': 'Please confirm your password',
  'memberPortal.profile.resetPassword.passwordMismatch': 'Passwords do not match',
  'memberPortal.profile.resetPassword.confirmPasswordPlaceholder': 'Confirm new password',
  'memberPortal.profile.resetPassword.cancel': 'Cancel',
  'memberPortal.profile.resetPassword.submit': 'Reset',
  'memberPortal.profile.phone.verificationTitle': 'Verify New Phone Number',
  'memberPortal.profile.phone.newMobile': 'New Mobile Number',
  'memberPortal.profile.phone.verificationCode': 'Verification Code',
  'memberPortal.profile.phone.codeRequired': 'Please enter verification code',
  'memberPortal.profile.phone.codeLength': 'Verification code must be 6 digits',
  'memberPortal.profile.phone.codePlaceholder': 'Enter 6-digit code',
  'memberPortal.profile.phone.sendCode': 'Send Verification Code',
  'memberPortal.profile.phone.resendText': 'Resend code in',
  'memberPortal.profile.phone.resend': 'Resend',
  'memberPortal.profile.phone.cancel': 'Cancel',
  'memberPortal.profile.phone.verify': 'Verify',
  'memberPortal.memberCard': 'Member Card',
  'pages.searchTable.new': 'New',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Please enter rule name',
  'pages.searchTable.updateForm.ruleDesc.descRules': 'Please enter a description of at least five characters',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'Please select start time',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.titleCallNo': 'Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'Closed',
  'pages.searchTable.nameStatus.running': 'Running',
  'pages.searchTable.nameStatus.online': 'Online',
  'pages.searchTable.nameStatus.abnormal': 'Abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled At',
  'pages.searchTable.titleOption': 'Actions',
  'pages.searchTable.config': 'Configure',
  'pages.searchTable.subscribeAlert': 'Subscribe to Alerts',
  'pages.searchTable.chosen': 'Selected',
  'pages.searchTable.item': 'items',
  'pages.searchTable.totalServiceCalls': 'Total Service Calls',
  'pages.searchTable.batchDeletion': 'Batch Delete',
  'pages.searchTable.batchApproval': 'Batch Approve',
  'cards.classification.label': 'Card Classification',
  'cards.classification.all': 'All classifications',
  'cards.classification.virtual': 'Virtual Card',
  'cards.classification.physical': 'Physical Card',
  'cards.classification.physical_virtualized': 'Physical Card (Virtualized)',
};
